module.exports = __webpack_public_path__ + "Lato-Medium.acbd6ecc97c80340e9bf.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Medium.woff
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Medium.woff
// module chunks = styles